"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        button: {
            backgroundColor: 'unset',
            cursor: 'pointer',
            display: 'inline-block',
            textAlign: 'center',
            lineHeight: 'normal',
            position: 'relative',
            padding: 0,
            borderRadius: 4,
            border: 'none',
            outlineOffset: -1,
            '&:focus-visible': {
                outline: "1px solid ".concat(theme_1.default.colors.primary),
            },
        },
        large: {
            width: 32,
            height: 32,
        },
    });
});
